import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpsUser, EliotUser, UserConsent, UserConsentStatus } from 'src/app/models/user/user.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

const userAPIVersion = "v3.0";
const touAPIVersion = "v2.0";

@Injectable()
export class RestUserService extends BaseApiService {


  constructor(httpClient : HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

  getEliotUser() : Observable<EliotUser>{
    return this.httpClient.get<EliotUser>(super.getEliotApiHost() + "users/api/" + userAPIVersion + "/users/profile", {headers : this.authService.eliotHttpHeaders});
  }

  getUser() : Observable<UpsUser>{
    return this.httpClient.get<UpsUser>(super.getUpsApiHost() + "Users/GetCurrentUser", {headers : this.authService.upsHttpHeaders});
  }

  updateUser(user : UpsUser): Observable<UpsUser> {
    return this.httpClient.put<UpsUser>(super.getUpsApiHost() + "Users/" + user.id , user, {headers : this.authService.upsHttpHeaders});
  }

  getPromotionalVideo(): Observable<any> {
    return this.httpClient.put<any>(super.getUpsApiHost() + "Users/PromotionalVideo",null, {headers : this.authService.upsHttpHeaders});
  }

  getUserConsent() : Observable<any>{
    return this.httpClient.get<any>(super.getEliotApiHost()+"users/api/" + userAPIVersion + "/users/consents", {headers : this.authService.eliotHttpHeaders});
  }

  getConsentStatus(languageId : string) : Observable<UserConsentStatus[]>{
    return this.httpClient.get<UserConsentStatus[]>(super.getEliotApiHost() + "termsandconditions/api/" + touAPIVersion + "/consent?language=" + languageId, {headers : this.authService.eliotHttpHeaders});
  }

  updateConditions(documentType: string): Observable<any>{
    let elem : any = {};
    return this.httpClient.post<any>(super.getEliotApiHost() + "termsandconditions/api/" + touAPIVersion + '/consent?documentType=' + documentType, elem, {headers : this.authService.eliotHttpHeaders});
  }

  getUsers() : Observable<UpsUser[]>{
    return this.httpClient.get<UpsUser[]>(super.getUpsApiHost() + "Users", {headers : this.authService.upsHttpHeaders});
  }

  saveMaintenanceReminderDays(maintenanceDays: number): Observable<any> {
    return this.httpClient.post<any>(super.getUpsApiHost() + 'Users/MaintenanceDaysReminder/' + maintenanceDays, null, { headers: this.authService.upsHttpHeaders });
  }

  saveWarrantyReminderDays(warrantyDays: number): Observable<any> {
    return this.httpClient.post<any>(super.getUpsApiHost() + 'Users/WarrantyDaysReminder/' + warrantyDays, null, { headers: this.authService.upsHttpHeaders });
  }

  getBackendVersion(): Observable<string> {
    return this.httpClient.get<string>(super.getUpsApiHost() + "version", {headers : this.authService.upsHttpHeaders});
  }

}
